/* eslint-disable no-shadow */
// eslint-disable-next-line sort-imports
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import { SetWindTurbinesFC } from "@/stores/actions/WindParkKPITable";
import {
	GET_WIND_TURBINES_CAPACITY_FACTOR,
	GET_WIND_TURBINES_CAPACITY_FACTOR_SUCCESS,
	GET_WIND_TURBINES_CAPACITY_FACTOR_ERROR,
} from "@/stores/actions/WindTurbinesCapacityFactor";

const state = {
	status:         FetchStatus.Init,
	successMessage: "",
	errorMessage:   "",
	data:           {},
	CFArray:        [],
};

const Qs = require("qs");

const actions = {
	[GET_WIND_TURBINES_CAPACITY_FACTOR]: ({ commit, dispatch }, monitoringElementsIds) =>
	{
		commit(GET_WIND_TURBINES_CAPACITY_FACTOR);
		const parameters = {};
		parameters.monitoringElementsIds = monitoringElementsIds;

		http.get("/WindTurbinesCapacityFactor", {
			params:           parameters,
			paramsSerializer: params => Qs.stringify(params,
				{ encode: false }),

		})
			.then((resp) =>
			{
				dispatch(SetWindTurbinesFC, resp.data);
				commit(GET_WIND_TURBINES_CAPACITY_FACTOR_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_WIND_TURBINES_CAPACITY_FACTOR_ERROR, error);
			});
	},
};
const mutations = {
	[GET_WIND_TURBINES_CAPACITY_FACTOR]: (state) =>
	{
		state.badData = false;
		state.status = FetchStatus.Loading;
	},
	[GET_WIND_TURBINES_CAPACITY_FACTOR_SUCCESS]: (state, data) =>
	{
		state.badData = false;
		state.performanceFactor = data;
		state.status = FetchStatus.Loaded;
	},
	[GET_WIND_TURBINES_CAPACITY_FACTOR_ERROR]: (state, error) =>
	{
		state.error = error.response;
		state.CFArray = [];
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
